import { StyleSheet } from 'aphrodite';
import { brandPrimaryText } from '../../../../../web/styles/colors';
import { CssSelectors, DefaultBorder } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	additionalInfo: {
		color: '#4a4a4a',
		fontSize: 12,
		marginLeft: 10,
		width: 200,
	},
	clickable: {
		cursor: 'pointer',
	},
	container: {
		marginBottom: 50,
		marginTop: 30,
		minHeight: 400,
		position: 'relative',
	},
	employeeList: {
		borderCollapse: 'collapse',
		borderWidth: 0,
		position: 'relative',
		tableLayout: 'fixed',
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'tr'
		),
	},
	employeeListTableHead: {
		backgroundColor: 'white',
		color: '#A7ABAD',
		fontSize: 12,
		marginBottom: 10,
		padding: '10px 0',
		paddingRight: 10,
	},
	employeeListTableHeader: {
		background: '#fff',
		fontWeight: 'normal',
		marginRight: 30,
		paddingBottom: 30,
		textAlign: 'center',
		top: 0,
		zIndex: 1,
	},
	employeeListTableHeadName: {
		align: 'right',
		minWidth: 300,
		paddingBottom: 30,
		position: 'sticky',
		top: 0,
		width: '25%',
	},
	employeeListTableHeadShrink: {
		overflow: 'visible',
		position: 'sticky',
		textOverflow: 'allow',
		width: 35,
	},
	expander: {
		height: 300,
	},
	inviteButton: {
		alignItems: 'center',
		background: '#E8F3F9',
		borderRadius: 18,
		color: brandPrimaryText,
		display: 'flex',
		fontSize: 14,
		height: 35,
		marginLeft: 20,
		width: 138,
	},
	menu: {
		background: '#fff',
		border: DefaultBorder,
		boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .1)',
		minWidth: 200,
	},
	menuItem: {
		':hover': {
			background: '#77777777',
		},
		cursor: 'pointer',
		fontSize: 14,
		fontWeight: 'normal',
		overflow: 'hidden',
		padding: '16px 20px',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	noDecoration: {
		color: 'black',
		textDecoration: 'none',
	},
	refreshIcon: {
		height: 30,
		marginTop: 5,
		width: 30,
	},
	unsupportedISP: {
		marginBottom: 10,
		maxWidth: 600,
	},
	userNameDropdown: {
		width: '100%',
	},
	errorContainer: {
		marginBottom: 16,
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: 20,
	},
	loadingMessage: {
		marginTop: 10,
		fontSize: 14,
		color: '#666',
		textAlign: 'center',
	},
});
